import Component from './InDmAvatar.vue'
export default Component
export * from './types'
